// Which chapter is this page for?
//
// The contract, and the reason this lives in one file: in development the
// chapter is chosen by environment - REACT_APP_SUBDOMAIN here and SUBDOMAIN on
// the backend, both set to the same chapter - because the CRA dev server is
// only reachable as plain localhost. Webpack answers "Invalid Host header" to
// aabea.localhost, so in development the host carries no subdomain to read and
// any screen that parsed it silently decided it was on a chapter site. In
// production the chapter comes from the real hostname, exactly as before.
const resolveSubDomain = (host = window.location.host) => {
  if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_SUBDOMAIN; // at dev only
  }
  // Production
  if (host.split(".")[0] === "www") {
    return host.split(".")[1];
  }
  return host.split(".")[0];
};

export default resolveSubDomain;
